<template>
  <div class="user-profile" :style="elSize">
    <div class="user-profile__container" v-tooltip="fullName">
      <img
        v-if="isValidPicture"
        class="user-profile__image"
        ref="profilePicture"
        v-lazy="pictureUrl"/>

      <span
        v-else-if="isValidName"
        class="user-profile__acronym">{{ displayName }}</span>

      <account-question-icon v-else class="user-profile__icon"/>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AccountQuestionIcon from '@/assets/icons/account-question.svg';

export default {
  components: {
    AccountQuestionIcon,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    picture: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    ...mapState(['token']),
    tokenQuery() {
      return `?token=${this.token}`;
    },
    pictureUrl() {
      return this.picture && this.picture.length > 0 ? `${this.picture}${this.tokenQuery}` : '';
    },
    displayName() {
      return this.name.length > 0 ? this.name.substr(0, 1) : '';
    },
    fullName() {
      return this.name.length > 0 ? this.name : '';
    },
    isValidPicture() {
      return this.pictureUrl.startsWith('http');
    },
    isValidName() {
      return this.displayName.match(/[a-zA-Z]/s) !== null;
    },
    elSize() {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`,
      };
    },
  },
};
</script>
